import Image, { ImageProps } from 'next/image';

const ImgContainer = ({ width = 500, height = 200, ...props }: any) => {
  let propsStyles;
  try {
    if (props?.style) {
      if (typeof props?.style === 'object') {
        propsStyles = props?.style;
      } else {
        const [key, value] = props?.style?.split(':');
        if (key && value) {
          propsStyles = { [key]: value };
        }
      }
    }
  } catch (error) {
    console.log('ImgContainer error', error);
  }

  return (
    <Image
      loader={({ src }) => (src || '')}
      width={width}
      height={height}
      style={{
        objectFit: 'contain',
        ...(propsStyles || {}),
      }} // Correct way to set object fit
      src={props?.src}
      alt={props?.alt || 'image'}
      className={props?.className || ''}
    />
  );
};

export default ImgContainer;
